export enum ORDER_SUCCESS_TITLE_CONST {
  TEST_ID = 'order-success-title',
}

export type TitleProps = {
  isPickupStore: boolean;
  orderCode: string;
  title?: string;
  titleShippingModel?: string;
};
